<template>
  <!-- <div class="container mt-0 background" -->
  <div class=" mt-0 background"

    style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; overflow: hidden;">
    <div style="height: auto" v-if="showItemList">
      <div class="
          row
          align-items-center
          justify-content-center
          align-self-center
          h-100
          mb-5
          text-center
        ">
        <div class="col-12 my-2 text-end p-0" style="background-color: #FFF1D9">
          <div>
            <div class="shalom">
              {{ translation.hello }}

              <!-- שלום חברים -->
            </div>
            <!-- <div class="divImageDetective">
              <img src="../../static/img/cavy-cute.gif" alt="" class="" />
            </div> -->
            <div class="textMainPage mt-3">
              {{ translation.archeology }}

            </div>
            <div class="mt-3 textMainPage" style="width: 250px; margin: 0 auto;">
              {{ translation.archeology2 }}
            </div>
            <div style="position: relative;">
              <img src="../../static/img/arrow.png" alt="" class=""
                style="position: absolute;bottom: -115px;left: -36px;" />
              <img src="../../static/img/stone.png" alt="" class=""
                style="position: absolute;bottom: -46px;right: -59px;" />
            </div>

            <div class="row tableValues">
              <div class="col-5">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                  <path
                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                </svg>
                סקרנות
              </div>
              <div class="col-7">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                  <path
                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                </svg>
                חשיבה מקורית
              </div>
              <div class="col-5">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                  <path
                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                </svg>
                סבלנות
              </div>
              <div class="col-7">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                  <path
                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                </svg>
                שימת לב לפרטים
              </div>
            </div>

            <!-- <ul class="mt-3">
              <li>
                סקרנות
              </li>
              <li>
                חשיבה מקורית
              </li>
              <li>
                שימת לב לפרטים קטנים וגדולים
              </li>
              <li>
                וסבלנות....
              </li>
            </ul> -->
            <div class="my-3 fw-bold text-center" style="font-size: 17px;">
              חושבים שאתם יכולים להיות בלשים טובים?
            </div>
            <div class="mb-3">
              לפניכם מספר חידות במוזיאון. בהצלחה
            </div>
            <div class="divImageDetective">
              <img src="../../static/img/cavy-cute.gif" alt="" class="" />
              <!-- <img src="../../static/img/man.png" alt="" class="" />
              <img src="../../static/img/woman.png" alt="" class="" /> -->

            </div>
            <img src="../../static/img/topSecret.png" alt="" class="topSecret" style="opacity: 30%" />

          </div>

          <button class="buttonStart" @click="startTest();
          ">
            צאו לדרך
          </button>
        </div>
      </div>
    </div>

    <div v-if="showTestPart1">
      <div>
        <div style="z-index: 2; position: relative;">
          <div class="clueIndex">
            רמז {{ indexClue }}
          </div>
          <img src="../../static/img/stone2.png" alt="" class="stone mt-3" style="z-index: 5;" />
        </div>
        <div style="position: relative; min-height: 170px; display: flex;align-items: center; justify-content: center;">
          <img src="../../static/img/parchemin.png" alt="" class="stone mt-3" style="position: absolute; bottom: -90px;" />
          <div id="demo" style="position: relative; width: 100%;">
          <!-- //********************************************************************************************* */ -->
          <div class="row mb-3 controlSlider m-0">
            <div class="row mx-0 mt-2 gx-0">
              <div class="col-2 p-0 arrowRight" @click="lessIndexClue" href="#demo" data-slide="prev">
                <svg xmlns="http://www.w3.org/2000/svg" width="70px" height="70px" fill="white"
                  class="bi bi-arrow-right-short" viewBox="0 0 16 16" style="stroke: white; stroke-width: 0.8;">
                  <path fill-rule="evenodd"
                    d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z" />
                </svg>
              </div>
              <div class="col-8 carouselText" style="padding-top: 17px; display: flex; justify-content: center">
                {{ arrayOfClue[clueIndex][index] }}
              </div>
              <div class="col-2 p-0 arrowLeft" @click="plusIndexClue" href="#demo" data-slide="next">
                <svg xmlns="http://www.w3.org/2000/svg" width="70px" height="70px" fill="white"
                  class="bi bi-arrow-left-short" viewBox="0 0 16 16" style="stroke: white; stroke-width: 0.8;">
                  <path fill-rule="evenodd"
                    d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        </div>
      
        <!-- CAROUSEL -->
        <!-- <div id="demo" 
        style="position: absolute; top: 150px; width: 100%;"> -->
        <!-- <div id="demo" class="carousel slide" data-ride="carousel" data-interval="false"
          style="position: absolute; top: 150px; width: 100%;"> -->
          <!-- The slideshow -->
        <!-- <div class="carousel-inner carouselText d-flex text-center">
            <div class="carousel-item active d-flex align-items-center justify-content-center">
              {{ arrayOfClue[clueIndex][0] }}
            </div>
            <div class="carousel-item d-flex align-items-center">
              {{ arrayOfClue[clueIndex][1] }}
            </div>
            <div class="carousel-item d-flex align-items-center">
              {{ arrayOfClue[clueIndex][2] }}
            </div>
            <div class="carousel-item d-flex align-items-center">
              {{ arrayOfClue[clueIndex][3] }}
            </div>
            <div class="carousel-item d-flex align-items-center" v-if="arrayOfClue[clueIndex][4]">
              {{ arrayOfClue[clueIndex][4] }}
            </div>
          </div>  -->
          <!-- {{ arrayOfClue[clueIndex][indexClue] }} -->

          <!-- //********************************************************************************************* */ -->
          <!-- <div class="row mb-3 controlSlider m-0">
            <div class="row mx-0 mt-2" style="width: 100%">
              <div class="col-2 ps-0 arrowRight" @click="lessIndexClue" href="#demo" data-slide="prev">
                <svg xmlns="http://www.w3.org/2000/svg" width="55px" height="55px" fill="currentColor"
                  class="bi bi-arrow-right-short" viewBox="0 0 16 16" style="left: 3px ; position: absolute;top: 7px;">
                  <path fill-rule="evenodd"
                    d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z" />
                </svg>
              </div>
              <div class="col-8" style="padding-top: 17px; display: flex; justify-content: center">
              </div>
              <div class="col-2 ps-4 pe-0 arrowLeft" @click="plusIndexClue" href="#demo" data-slide="next">
                <svg xmlns="http://www.w3.org/2000/svg" width="55px" height="55px" fill="currentColor"
                  class="bi bi-arrow-left-short" viewBox="0 0 16 16" style="right: 5px; position: relative;top: 8px;">
                  <path fill-rule="evenodd"
                    d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z" />
                </svg>
              </div>
            </div>
          </div> -->
        <!-- </div> -->

        <!-- //*********************************************showAnswerPart1************************************************ */ -->

        <div class="p-3" style="position: relative;" v-if="showAnswerPart1">
          <div class="text-center mt-4 h4 didYouFindMe">מצאתם אותי?</div>
          <div class="row mb-3">
            <div class="text-end col-12 ps-0 textQuestion mb-2">
              מה אני?
            </div>
            <div class="px-0 col-10 me-4">
              <input type="text" name="item2word" label="item2word" class="input" v-model="item2word" />
            </div>
          </div>
          <div class="row">
            <div class="text-end col-12 ps-0 textQuestion mb-2">מעלי כתוב:</div>
            <div class="col-1 text-end p-0 mx-2 h4">בין</div>
            <div class="px-0 col-9">
              <input type="text" name="item1word" label="item1word" class="input" v-model="item1word" />
            </div>
          </div>
          <button class="
          fw-bold position-relative buttonStart mt-5
            " @click="checkAnswer1()" style="bottom: 0px;">
            בדיקה
          </button>
        </div>

        <!-- //*********************************************showAnswerPart2************************************************ */ -->


        <div class="p-3" style="position: relative;" v-if="showAnswerPart2">
          <div class="text-center mt-4 h4 didYouFindMe">מצאתם אותי?</div>
          <div class="row mb-3">
            <div class="text-end col-12 ps-0 textQuestion mb-2">
              המספר שלי בתצוגה:
            </div>
            <div class="px-0 col-10 me-4">
              <input type="text" name="item3word" label="item3word" class="input" v-model="item3word" />
            </div>
          </div>
          <button class="
          fw-bold position-relative buttonStart mt-5
            " @click="checkAnswer2()" style="bottom: 0px;">
            בדיקה
          </button>
        </div>

        <!-- //*********************************************showAnswerPart3************************************************ */ -->

        <div class="p-3" style="position: relative;;" v-if="showAnswerPart3">
          <div class="text-center mt-4 h4 didYouFindMe">מצאתם אותי?</div>
          <div class="row mb-3">
            <div class="text-end col-12 ps-0 textQuestion mb-2">
              כמה חפצים נמצאים סביבי?
            </div>
            <div class="px-0 col-10 me-4">
              <input type="text" name="item4word" label="item4word" class="input" v-model="item4word" />
            </div>
          </div>
          <button class="
          fw-bold position-relative buttonStart mt-5
            " @click="checkAnswer3()" style="bottom: 0px;">
            בדיקה
          </button>
        </div>
      </div>
    </div>

        <!-- //*********************************************SHOW CORRECT ANSWER 1************************************************ */ -->


    <div v-if="showCorrectAnswer1" class="over">
      <div class="
          row
          align-items-center
          justify-content-center
          align-self-center
          h-100
        ">
        <div class="p-3 myModal h4"
          style="    background-color: #71A83F; color: white; border: 14px solid rgb(255 255 255); font-size: 25px;">
          <div class="py-3 text-center" style="font-size: 30px;">
            איזה יופי!
          </div>
          <div class="py-2 text-center">
            פתרתם נכון את החידה הראשונה.
            <br />
            בואו נראה אם אתם מצליחים לפתור את החידה השניה.
          </div>
          <img src="../../static/img/man.png" alt="" class="photoRightAnswer">
          <button class="fw-bold position-relative mt-5 buttonWrongAnswer" style="bottom: 57px;" @click="
            showCorrectAnswer1 = false;
            // showTestPart1 = false;

          showAnswerPart2 = true;
          ">
            המשך
          </button>
        </div>
      </div>
    </div>



            <!-- //*********************************************SHOW CORRECT ANSWER 2************************************************ */ -->

    <div v-if="showCorrectAnswer2" class="over">
      <div class="
          row
          align-items-center
          justify-content-center
          align-self-center
          h-100
        ">
        <div class="p-3 myModal h4"
          style="    background-color: #71A83F; color: white; border: 14px solid rgb(255 255 255); font-size: 25px;">
          <div class="py-3 text-center" style="font-size: 30px;">
            מצויין!
          </div>
          <div class="py-2 text-center">
            פתרתם נכון את החידה השניה.
            <br />
            בואו נמשיך.
          </div>
          <img src="../../static/img/man.png" alt="" class="photoRightAnswer">
          <button class="fw-bold position-relative mt-5 buttonWrongAnswer" style="bottom: 57px;" @click="
            showCorrectAnswer2 = false;
          //  showTestPart2 = false;

          showAnswerPart3 = true;
          ">
            המשך
          </button>
        </div>
      </div>
    </div>

            <!-- //*********************************************SHOW CORRECT ANSWER 3************************************************ */ -->


    <div v-if="showCorrectAnswer3" class="over">

      <div class="
          row
          align-items-center
          justify-content-center
          align-self-center
          h-100
        ">
        <div class="p-3 myModal h4"
          style="    background-color: #71A83F; color: white; border: 14px solid rgb(255 255 255); font-size: 25px;">
          <div class="py-3 text-center" style="font-size: 30px;">
            מעולה!
          </div>
          <div class="py-2 text-center">
            גם הפעם פתרתם נכון את החידה.
            <br />
            אתם בלשים מצויינים. כמעט סיימתם
          </div>
          <img src="../../static/img/man.png" alt="" class="photoRightAnswer">
          <button class="fw-bold position-relative mt-5 buttonWrongAnswer" style="bottom: 57px;" @click="
            showCorrectAnswer3 = false;
           showAnswerPart3 = false;

          showTestPart4 = true;
          ">
            המשך
          </button>
        </div>
      </div>
    </div>

    <div v-if="allBoxesChecked && showFirstModal" class="over">
      <div class="
          row
          align-items-center
          justify-content-center
          align-self-center
          h-100
        ">
        <div class="p-3 myModal" style="background-color: rgb(136 202 241)">
          <div class="py-3 text-center" style=" font-size: 17px">
            יופי, עכשיו יש לכם את כל הציוד. אתם יכולים להתחיל את מבחן הבלשות!
          </div>
          <div class="text-center mt-4">
            על מנת לעבור את מבחן הבלשות, עליכם למצוא חפצים בשני חדרי התצוגה על
            פי רמזים שתקבלו.
          </div>
          <div class="text-center mt-4" style=" font-size: 20px">
            בהצלחה!
          </div>

          <button class="roundButton colorBtn btn fw-bold position-relative"
            style="background-color: rgb(5 183 60); margin-top: 30px" @click="startTest();">
            להתחיל
          </button>
        </div>
      </div>
    </div>

    <div v-if="wrongAnswer" class="over" style="
        background: #80808066;
        z-index: 41;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
      ">
      <div class="
          row
          align-items-center
          justify-content-center
          align-self-center
          h-100
        ">
        <div class="p-3 myModal wrongAnswer">
          <div class="py-3 text-center" style=" color: white; font-size: 30px">
            התושבה לא נכונה!
          </div>
          <button class="
           fw-bold position-relative my-3 buttonWrongAnswer" style="
              margin-top: 30px;
              font-size: 20px;
            " @click="wrongAnswer = false">
            ננסה שוב
          </button>
        </div>
      </div>
    </div>

            <!-- //*********************************************showAnswerPart4************************************************ */ -->


    <!-- <div v-if="showTestPart4" class="over" style="font-family: system-ui;">
      <div class="row align-items-center justify-content-center align-self-center" style="background: #252c40;">
        <div class="p-3 myModal" style="    background-color: #FFF1D9;
    border: 8px solid #71A83F;
    font-size: 20px;
    max-width: 390px;
    width: 100%;">
          <div class="mt-4 fw-bold ">
            האם אתם יודעים מה הם החפצים הנמצאים סביבי?
          </div>
          <div class="mt-2">
            בואו נבדוק.
          </div>
          <div class="mt-4">רשמו את מספר ההגדרה לצד כל אחד מהחפצים.</div>

          <div class="row my-1 mx-0">
            <div class="text-end col-6 ps-0" style="position: relative">
              <img class="imageInput" src="../../static/img/bague.jpeg" alt="" />
              <input type="text" class="inputOnImage" v-model="answerQuestion1" />
            </div>
            <div class="text-end col-6 ps-0" style="position: relative">
              <img class="imageInput" src="../../static/img/bol.jpeg" alt="" />
              <input type="text" class="inputOnImage" v-model="answerQuestion2" />
            </div>
          </div>
          <div class="row my-1 mx-0">
            <div class="text-end col-6 ps-0" style="position: relative">
              <img class="imageInput" src="../../static/img/bouteille1.jpeg" alt="" />
              <input type="text" class="inputOnImage" v-model="answerQuestion3" />
            </div>
            <div class="text-end col-6 ps-0" style="position: relative">
              <img class="imageInput" src="../../static/img/tsafrat.jpeg" alt="" />
              <input type="text" class="inputOnImage" v-model="answerQuestion4" />
            </div>
          </div>
          <div class="row my-1 mx-0">
            <div class="text-end col-6 ps-0" style="position: relative">
              <img class="imageInput" src="../../static/img/bouteille3.jpeg" alt="" />
              <input type="text" class="inputOnImage" v-model="answerQuestion5" />
            </div>
            <div class="text-end col-6 ps-0" style="position: relative">
              <img class="imageInput" src="../../static/img/gdera.jpeg" alt="" />
              <input type="text" class="inputOnImage" v-model="answerQuestion6" />
            </div>
          </div>
          <div style="font-size: 17px">
            <span class="fw-bold"> 1. צפחת</span>
            - כלי עשוי חרס בצורת עדשה. שימש לנוזלים בדומה למימיה
          </div>
          <div style="font-size: 17px">
            <span class="fw-bold"> 2. קובעת</span>
            - קערת חרס העומדת על רגל גבוהה - מתגלה בדרך כלל בקברים או במקדשים
          </div>
          <div style="font-size: 17px">
            <span class="fw-bold">3. קדרה</span> - כלי קיבול ואחסון
            לגרעינים וקמח
          </div>
          <div style="font-size: 17px">
            <span class="fw-bold"> 4. טבעת עם עיטור חרפושית</span> -
            טבעת ששימשה כחותם
          </div>
          <div style="font-size: 17px" class="fw-bold">
            5. קערת חרס
          </div>
          <button class="
          btn fw-bold position-relative btn-primary btn-lg btn3d mt-5
            " @click="checkAnswer4()">
            בדיקה
          </button>
        </div>
      </div>
    </div> -->

    <div v-if="showTestPart4" class="over" style="font-family: system-ui;">
      <MultipleMatch
        :show-multiple-match="showMultipleMatch"
        :points="$store.getters.points"
        :points-array-order="$store.getters.pointsArrayOrder"
        :point-num="pointNum"
        @error-increment="errorNumber++"
        @error-decrement="errorNumber--"
        @quiz-completed="onQuizCompleted"
      />
    </div>

        <!-- //*********************************************showAnswerPart5************************************************ */ -->


    <div v-if="showTestPart5" class="over">
      <div class="
          row
          align-items-center
          justify-content-center
          align-self-center
          h-100
        ">
        <div class="p-3 myModal" style="background-color: #FFF1D9; font-size: 20px">
          <div class="mt-4">אם הגעתם עד לכאן, זה אומר שאפשר לסמוך עליכם.</div>
          <div class="mt-4">
            הפרופסור ששמעתם קודם עומדת מול אתגר מאוד גדול וכנראה תוכלו לעזור לה.
          </div>
          <div class="mt-4">
            אם תענו נכון על השאלות הבאות, תוכלו לצאת לדרך ולעזור לפרופסור.
          </div>

          <button class="
              roundButton
              colorBtn
              btn
              fw-bold
              position-relative
              mt-3
            " style="background-color: rgb(5 183 60); font-size: 20px" @click="
              showTestPart5 = false;
            showTestPart6 = true;
            ">
            המשך
          </button>
        </div>
      </div>
    </div>
    <div v-if="dialogWrongAnswer" class="over">
      <div class="myModal p-4 mb-5 red container d-flex" @click="(dialogWrongAnswer = false), (missingWordAnswer = '')">
        <div class="row justify-content-center align-self-center p-5" style="
            color: white;
            background: #d41a1b;
            z-index: 9;
            border-radius: 22px;
          ">
          <div class="col-12 h2 mb-4 text-center" style="font-family: noot">
            הופס...
          </div>
          <div class="col-12 mb-4 text-center">התשבה לא נכונה</div>
          <audio id="audio" controls autoplay style="display: none">
            <source src="../../static/sounds/buzzerWrong.mp3" type="audio/mp3" />
          </audio>

          <div class="btn fw-bold position-relative btn-primary btn-lg btn3d mt-5" style="width: 100%">
            בואו ננסה שוב!
          </div>
        </div>
      </div>
    </div>
    <div v-if="showTestPart6" class="over">
      <div class="
          row
          align-items-center
          justify-content-center
          align-self-center
          h-100
        ">
        <div class="p-3 myModalFull" style="background-color: #FFF1D9; font-size: 20px">
          <div id="questionDiv" style="display: block" align="center">
            <div class="my-5 px-1">
              <p class="question px-3" right>{{ questions[indexQuestions] }}</p>
            </div>
            <div :key="answer.id" v-for="answer in answers[indexQuestions]">
              <button class=" btn fw-bold position-relative btn-primary btn-lg btn3d mt-5"
                style="background-color: #4f9e2c" @click="checkAnswerQuestion(answer)">
                {{ answer }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="over" v-if="showCorrectAnswer4" style="position: fixed">
      <div class="
          row
          align-items-center
          justify-content-center
          align-self-center
          h-100
        ">
        <div class="p-3 myModal" style="background-color: #FFF1D9">
          <div class="py-3 text-center" style=" font-size: 30px">
            כל הכבוד!
          </div>
          <div class="py-3 text-center" style="font-size: 20px">
            נותרה לכם עוד משימה אחרונה לפני שתקבלו את תעודת 'בלש מוסמך'.
          </div>
          <div class="py-3 text-center" style="font-size: 20px">
            תהיו מרוכזים!
          </div>

          <button class="
              roundButton
              colorBtn
              btn
              fw-bold
              position-relative
              mt-3
            " style="background-color: rgb(5 183 60); font-size: 20px" @click="
              showTestPart6 = true;

            showTestPart4 = false;
            showCorrectAnswer4 = false;
            ">
            המשך
            <!-- showTestPart5 = true; -->
          </button>
        </div>
      </div>
    </div>
    <div class="over" v-if="showLastScreen">
      <div class="
          row
          align-items-center
          justify-content-center
          align-self-center
          h-100
        ">
        <div class="p-3 myModalFull" style="background-color: #FFF1D9">
          <div class="pt-3 text-center" style=" font-size: 30px">
            כל הכבוד!
          </div>
          <div class="pb-3 text-center" style="font-size: 20px">
            עברתם את מבחן הבלשות בהצלחה.
          </div>
          <img src="../../static/img/DetectiveLicence.png" class="licenceImage" alt="" />
          <div class="detectiveName">{{ detectiveName }}</div>
          <div class="py-3 text-center" style="font-size: 20px; margin-bottom: 60px"></div>
        </div>
      </div>
    </div>
    <!-- <Map /> -->
  </div>
</template>

<script>
import MultipleMatch from "./multipleMatch";

// import Map from "./map";
export default {
  components: {
    MultipleMatch,
  },
  data() {
    return {
      // clueToShow: this.getClueToShow,
      showMultipleMatch: true,
      errorNumber: 0,
      pointNum: 0,
      showAnswerPart1: true,
      showAnswerPart2: false,
      showAnswerPart3: false,
      clueIndex: 0,
      arrayOfClue: [['יש לי שתי ידיות', 'התחתית שלי מחודדת', 'אני כלי אגירה לנוזלים, בעיקר שמן זית', 'שמי בגימטריה: 50-100-50-100 '],
      ['אני כלי מדליק', '"השקו" אותי בשמן זית', 'השתמשו בי בלילה', 'אני כלי להחזקת האש', 'יש לי 6 "עיניים", לא כמו כל הדומים לי'],
      ['ענדתי טבעת חותם', 'אני בן 3000 שנה', 'קנקנים הם ביתי החדש', 'אני נח על חול ים']],
      indexClue: 1,
      index: 0,
      indexQuestions: 0,
      questions: [
        "בן כמה האדם שקבור בקנקנים?",
        "כמה מטבעות מוצגים במוזיאון?",
        "באיזה שנה הוקם המוזיאון?",
      ],
      answers: [
        {
          wrongAnswer1: "בן 500 שנה",
          correctAnswer: "בן 3000 שנה",
          wrongAnswer2: "בן 4000 שנה",
          wrongAnswer3: "בן 1000 שנה",
        },
        {
          wrongAnswer1: "5 מטבעות",
          wrongAnswer2: "11 מטבעות",
          correctAnswer: "22 מטבעות",
          wrongAnswer3: "51 מטבעות",
        },
        {
          wrongAnswer1: "1948 ",
          wrongAnswer2: "1962",
          wrongAnswer3: "2001",
          correctAnswer: "1986",
        },
      ],
      answerQuestion1: "",
      answerQuestion2: "",
      answerQuestion3: "",
      answerQuestion4: "",
      answerQuestion5: "",
      answerQuestion6: "",
      dialogWrongAnswer: false,
      showTestPart2: false,
      showTestPart3: false,
      showTestPart4: false,
      showTestPart5: false,
      showTestPart6: false,
      showCorrectAnswer1: false,
      showCorrectAnswer2: false,
      showCorrectAnswer3: false,
      showCorrectAnswer4: false,

      item1word: "",
      item2word: "",
      item3word: "",
      item4word: "",
      checked: [],
      showItemList: true,
      showRecording: false,
      // question2: false,
      explaination1: true,
      betBadAnswer2: "",
      wrongAnswer: false,
      secondsToTime: "05:00",
      showFinishedQuestionPart: false,
      firstTime: true,
      greatAnswer: false,
      gotResults: false,
      showTestPart1: false,
      showFirstModal: true,
      showLastScreen: false,
      translation: {
        hello: "שלום ילדים",
        archeology: "ארכיאולוג הוא בלש של העבר. באמצעות חקר והתבוננות בממצאים שנמצאו בחפירות ארכיאולוגיות, הוא יודע לספר כמה דברים על האנשים שחיו בעבר ועל השימושים של החפצים שלהם.",
        archeology2: " ארכיאולוג נדרש למספר תכונות כדי שיהיה בלש מצויין:",
        adultTour: "סיור במוזיאון",
        childrenTour: "סיור ילדים",
        quote: "'ובְחֶשְכַת הַלַּיְל בְּלִי קֶשֶׁת וְשֶלַח עַל סוּס קַל עֱין דּוֹרָה בָּא שָׁאוּל הַמֶּלֶךְ'",
        quoteName: "(ש. טשרניחובסקי - 'בְּעֵין דּוֹר')",
        welcomeText: "אנו מציעים לכם שימוש במדריך הדיגיטלי המלווה את התצוגה במוזיאון, באמצעותו תצאו למסע הכרות ומפגש בין אדם לאדמה ובין אדם לאדם באזורנו, הכרות עם החזון והמטרות של המוזיאון ועם הממצאים המוצגים. מרבית הממצאים הם בהשאלת קבע מאוצרות המדינה באמצעות רשות העתיקות. בבסיס התצוגה הארכיאולוגית נמצא העיסוק בעושר התרבותי של האזור, היותו אזור מפגש בין תרבויות וזהויות שחיו בסמיכות אלו בצד אלו לכל אורך ההיסטוריה וגם כיום. אנו מזמינים אתכם לקחת את הזמן ולאפשר לעצמכם להתבונן בפריטים, לקרוא אודותיהם ולהפליג על מפרשי הדמיון. היישומון ערוך כך שתוכלו למצוא הרחבות לנושאים, לממצאים ולחפצים המעניינים אתכם.",
        aboutMuseum: "על המוזיאון",
        aboutPlace: "על המקום",
        aboutExibithion: "על התצוגה"
      }
    };
  },
  computed: {
    detectiveName() {
      if (localStorage.getItem("einDorQuestGameUserName")) {
        return localStorage.getItem("einDorQuestGameUserName");
      } else {
        return "";
      }
    },
    allAnswersCorrect() {
      if (
        this.correct1 === true &&
        this.correct2 === true &&
        this.correct3 === true &&
        this.correct4 === true &&
        this.correct5 === true &&
        this.correct6 === true
      ) {
        console.log("allAnswersCorrect");
        // if (this.correct1 === true) {
        return true;
      } else {
        return false;
      }
    },
    correct1() {
      if (this.answerQuestion1 === "4") {
        return true;
      } else {
        return false;
      }
    },
    correct2() {
      if (this.answerQuestion2 === "5") {
        return true;
      } else {
        return false;
      }
    },
    correct3() {
      if (this.answerQuestion3 === "1") {
        return true;
      } else {
        return false;
      }
    },
    correct4() {
      if (this.answerQuestion4 === "2") {
        return true;
      } else {
        return false;
      }
    },
    correct5() {
      if (this.answerQuestion5 === "1") {
        return true;
      } else {
        return false;
      }
    },
    correct6() {
      if (this.answerQuestion6 === "3") {
        return true;
      } else {
        return false;
      }
    },
    allBoxesChecked() {
      if (this.checked.length == 5) {
        return true;
      } else {
        return false;
      }
    },

    error() {
      return this.$store.getters.error;
    },
    // loading() {
    //   return this.$store.getters.loading;
    // }
  },
  methods: {
    onQuizCompleted() {
      this.showTestPart6 = true;
      this.showTestPart4 = false;
      this.showCorrectAnswer4 = false;
    },
    // getClueToShow(){
    //   console.log("this.arrayOfClue[this.clueIndex][this.indexClue]", this.arrayOfClue[this.clueIndex][this.indexClue])
    //   // this.arrayOfClue[this.clueIndex][this.indexClue]
    // },
    plusIndexClue() {
    
     console.log("this.arrayOfClue[this.clueIndex][this.indexClue]", this.arrayOfClue[this.clueIndex][this.indexClue]) 
      if (this.indexClue > 3) {
        this.indexClue = 1
        this.index = this.indexClue - 1
             console.log("this.arrayOfClue[this.clueIndex][this.indexClue]", this.arrayOfClue[this.clueIndex][this.indexClue]) 
      } else {
        this.indexClue = this.indexClue + 1
        this.index = this.indexClue - 1
             console.log("this.arrayOfClue[this.clueIndex][this.indexClue]", this.arrayOfClue[this.clueIndex][this.indexClue]) 
      }
    },
    lessIndexClue() {
           console.log("this.arrayOfClue[this.clueIndex][this.indexClue]", this.arrayOfClue[this.clueIndex][this.indexClue]) 
      if (this.indexClue < 2) {
        this.indexClue = 4
        this.index = this.indexClue - 1
             console.log("this.arrayOfClue[this.clueIndex][this.indexClue]", this.arrayOfClue[this.clueIndex][this.indexClue]) 
      } else {
        this.indexClue = this.indexClue - 1
        this.index = this.indexClue - 1
             console.log("this.arrayOfClue[this.clueIndex][this.indexClue]", this.arrayOfClue[this.clueIndex][this.indexClue]) 
      }
    },
    translate() {
      if (this.lang == "he") {
        this.translation = {
          hello: "שלום ילדים",
          archeology: "ארכיאולוג הוא בלש של העבר. באמצעות חקר והתבוננות בממצאים שנמצאו בחפירות ארכיאולוגיות, הוא יודע לספר כמה דברים על האנשים שחיו בעבר ועל השימושים של החפצים שלהם.",
          archeology2: " ארכיאולוג נדרש למספר תכונות כדי שיהיה בלש מצויין:",
          adultTour: "סיור במוזיאון",
          childrenTour: "סיור ילדים",
          quote: "'ובְחֶשְכַת הַלַּיְל בְּלִי קֶשֶׁת וְשֶלַח עַל סוּס קַל עֱין דּוֹרָה בָּא שָׁאוּל הַמֶּלֶךְ'",
          quoteName: "(ש. טשרניחובסקי - 'בְּעֵין דּוֹר')",
          archeologyText: "אנו מציעים לכם שימוש במדריך הדיגיטלי המלווה את התצוגה במוזיאון, באמצעותו תצאו למסע הכרות ומפגש בין אדם לאדמה ובין אדם לאדם באזורנו, הכרות עם החזון והמטרות של המוזיאון ועם הממצאים המוצגים. מרבית הממצאים הם בהשאלת קבע מאוצרות המדינה באמצעות רשות העתיקות. בבסיס התצוגה הארכיאולוגית נמצא העיסוק בעושר התרבותי של האזור, היותו אזור מפגש בין תרבויות וזהויות שחיו בסמיכות אלו בצד אלו לכל אורך ההיסטוריה וגם כיום. אנו מזמינים אתכם לקחת את הזמן ולאפשר לעצמכם להתבונן בפריטים, לקרוא אודותיהם ולהפליג על מפרשי הדמיון. היישומון ערוך כך שתוכלו למצוא הרחבות לנושאים, לממצאים ולחפצים המעניינים אתכם.",
          aboutMuseum: "על המוזיאון",
          aboutPlace: "על המקום",
          aboutExibithion: "על התצוגה"
        }
      } else {
        this.translation = {
          hello: "Hello my friends",

          archeology: "Welcome to",
          archeology2: " ארכיאולוג נדרש למספר תכונות כדי שיהיה בלש מצויין:",
          adultTour: "Adult tour",
          childrenTour: "Children tour",
          quote: "'By cloak of night without bow or javelin... on a swift horse to Ein Dor comes Saul the King.'",
          quoteName: "In Ein Dor by Shaul Tchernichovsky",
        }
      }

    },
    checkAnswerQuestion(answer) {
      if (document.getElementById("questionDiv")) {
        document.getElementById("questionDiv").classList.remove("fadeIn");
      } else {
        console.log("[checkAnswer] No questionDiv");
      }
      if (answer === this.answers[this.indexQuestions].correctAnswer) {
        console.log(this.indexQuestions);
        if (this.indexQuestions === 2) {
          console.log("finish the game");
          this.showLastScreen = true;
        } else {
          console.log("correctAnswer");
          this.indexQuestions++;
        }
      } else {
        this.dialogWrongAnswer = true;
      }
    },
    checkAnswer1() {
      if ((this.item1word == "מצרים לכנען" || this.item1word == "בין מצרים לכנען") && this.item2word == "קנקן") {
        this.showCorrectAnswer1 = true;
        // this.showTestPart1 = false;
        this.showAnswerPart1 = false
        // this.showAnswerPart2 = true
        this.clueIndex = this.clueIndex + 1
        this.showFirstModal = false;
      } else {
        this.wrongAnswer = true;
      }
    },
    checkAnswer2() {
      if (this.item3word === "6") {
        this.showCorrectAnswer2 = true;
        this.showAnswerPart2 = false;
        this.clueIndex = this.clueIndex + 1
        this.showFirstModal = false;
      } else {
        this.wrongAnswer = true;
      }
    },
    checkAnswer3() {
      console.log("checkAnswer3", this.item4word);
      if (this.item4word == "7") {
        this.showCorrectAnswer3 = true;
        this.showTestPart3 = false;
        this.showFirstModal = false;
        console.log("checkAnswer1 CORRECT", this.item4word);
      } else {
        this.wrongAnswer = true;
      }
    },
    checkAnswer4() {
      if (this.allAnswersCorrect === true) {
        this.showCorrectAnswer4 = true;
      } else {
        this.wrongAnswer = true;
      }
    },
    startTest() {
      setTimeout(() => {
        this.showItemList = false;
        this.showTestPart1 = true;
        this.showFirstModal = false;
        window.scrollTo(0, 0);
      }, 1000)
    },
    onDismissed() {
      this.$store.dispatch("clearError");
    },
  },
};
</script>

<style scoped>
.photoRightAnswer {
  position: relative;
  right: 17px;
  height: 285px;
}

.buttonWrongAnswer {
  margin-top: 30px;
  font-size: 20px;
  width: 200px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  border: none;
  border-radius: 24px;

}

.textQuestion {
  font-size: 25px;
  font-weight: bold;
  color: black;
}

.clueIndex {
  top: 16px;
  position: absolute;
  font-size: 30px;
  font-weight: bold;
  width: 100%;
  display: flex;
  justify-content: center;
  color: black;
}

.arrowRight {
  height: 100px;
  width: 50px;
  background: #71A83F;
  border-bottom-left-radius: 50px;
  border-top-left-radius: 50px;
  border-top-width: 5px;
  border-right-width: 0px;
  border-bottom-width: 5px;
  border-left-width: 5px;
  border-color: white;
  border-style: solid;
  border-bottom-width: 15px;
  border-top-width: 15px;
  border-left-width: 15px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.arrowLeft {
  height: 100px;
  width: 50px;
  background: #71A83F;
  border-bottom-right-radius: 50px;
  border-top-right-radius: 50px;
  border-top-width: 5px;
  border-right-width: 5px;
  border-bottom-width: 5px;
  border-left-width: 0px;
  border-color: white;
  border-style: solid;
  border-bottom-width: 15px;
  border-top-width: 15px;
  border-right-width: 15px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.stone {
  margin: 0 auto;
  display: block;
}

.buttonStart {
  height: 100px;
  width: 350px;
  background-color: #71A83F;
  color: white;
  font-size: 30px;
  font-weight: bold;
  border: solid white 10px;
  border-radius: 50px;
  margin: 0 auto;
  display: block;
  z-index: 1;
  bottom: 72px;
  position: relative;

}

.tableValues {
  height: 80%;
  background: white;
  padding: 20px;
  width: 370px;
  margin: 0 auto;
  padding: 10px;
  margin-top: 20px;
  font-size: 17px;
  font-weight: bold;
}

.tableValues svg {
  color: #71A83F !important;
}

.textMainPage {
  text-align: center;
  font: normal normal normal 17px/22px Segoe UI;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.myModalClue {
  background-color: #FFF1D9 !important;
  font-size: 20px;
  border: solid orange 8px !important;
}

.myModalClue .active {
  font-family: danaYad;
}

.carouselText {
    color: white;
    font-weight: bold;
    font-size: 30px;
    margin: 0 auto;
    text-align: center;
}

.carousel-item.active {
  display: block;
  left: -100% !important;
  padding: 10px;
  justify-content: center;
}

a span {
  position: relative;
  /* top: -112px; */
}

a span.carousel-control-next-icon {
  padding-right: 38px;
  padding-bottom: 30px;
}

a span.carousel-control-prev-icon {
  padding-left: 110px;
  padding-bottom: 30px;
}

.wrongAnswer {
  background-color: rgb(217 71 71) !important;
  z-index: 18;
  color: white;
  width: 300px;
  border: solid 14px white !important;
}

.didYouFindMe {
  color: black;
  /* color: rgb(83, 94, 161); */
  /* border-top: 2px black dotted; */
  padding-top: 20px;
  font-size: 35px;
  font-weight: bold;
}

.input {
  width: 100%;
  /* background: transparent; */
  border: none;
  /* border-bottom: solid 2px grey; */
  border-top: solid 4px #80808026;
  height: 40px;
}

.carousel-control-next,
.carousel-control-prev {
  opacity: 1 !important;
}

.btn3d {
  position: relative;
  top: -6px;
  border: 0;
  transition: all 40ms linear;
  margin: 20px auto;
  display: block;
  width: 200px;
  border-radius: 16px;
}

.btn3d:active:focus,
.btn3d:focus:hover,
.btn3d:focus {
  -moz-outline-style: none;
  outline: medium none;
}

.btn3d:active,
.btn3d.active {
  top: 2px;
}

.btn3d.btn-primary {
  box-shadow: 0 0 0 1px #417fbd inset, 0 0 0 2px rgba(255, 255, 255, 0.15) inset,
    0 8px 0 0 #4d5bbe, 0 8px 8px 1px rgba(0, 0, 0, 0.5);
  background-color: #4274d7;
}

.btn3d.btn-primary:active,
.btn3d.btn-primary.active {
  box-shadow: 0 0 0 1px #417fbd inset, 0 0 0 1px rgba(255, 255, 255, 0.15) inset,
    0 1px 3px 1px rgba(0, 0, 0, 0.3);
  background-color: #4274d7;
}

ul {
  background: white;
  border: solid 4px #535ea1;
  padding: 16px;
  padding-right: 15px;
  list-style: none;
  min-width: 320px;
  font-family: danaYad;
  font-size: 21px;
  font-weight: 600;
}

li {
  padding-bottom: 2px;
  border-bottom: 1px black solid;
}

ul li:before {
  content: '✓';
  font-size: 20px;
}

.shalom {
  font-weight: 800;
  font-size: 25px;
  text-align: center;
  color: #71A83F;
}


.divImageDetective {
  background: white;
  height: 300px;
  width: 300px;
  border-radius: 100%;
  /* border: #7f91ff 11px solid; */
  overflow: hidden;
  margin: 5px auto 20px;
}

.divImageDetective img {
  height: 228px;
  margin: 0 auto;
  display: block;
  top: 26px;
  position: relative;
}

.detectiveName {
  position: relative;
  bottom: 189px;
  width: 100%;
  text-align: center;
  margin: 0 auto;
  display: block;
}

.licenceImage {
  width: 100%;
}

.fadeIn {
  -webkit-animation: fadein 1s;
  /* Safari, Chrome and Opera > 12.1 */
  -moz-animation: fadein 1s;
  /* Firefox < 16 */
  -ms-animation: fadein 1s;
  /* Internet Explorer */
  -o-animation: fadein 1s;
  /* Opera < 12.1 */
  animation: fadein 1s;
}

@keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Internet Explorer */
@-ms-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.imageInput {
  width: 100%;
}

.inputOnImage {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 5px;
  left: 5px;
  text-align: center;
}

.topSecret {
  position: absolute;
  bottom: 241px;
  left: -88px;
  width: 248px;
}

.roundButton {
  height: 80px !important;
  width: 80px;
  border-radius: 51px !important;
  border: solid 1px white;
  display: block;
  margin: 0 auto;
}

.inputSecretCode {
  width: 40px;
}

.stopButton {
  border-radius: 10px;
  background-color: rgb(183 26 5);
  margin-top: 30px;
  font-size: 24px;
  height: 50px;
  width: 50px;
  border: solid 2px white;
}

.recButton {
  border-radius: 50px;
  background-color: rgb(183 26 5);
  margin-top: 30px;
  font-size: 24px;
  height: 50px;
  width: 50px;
  border: solid 15px white;
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    border: solid 10px white;
  }
}

.green {
  border: solid 5px #05e01c !important;
}

.image {
  width: 100%;
}

#timer {
  height: 62px;
  background: brown;
  padding-top: 11px;
  color: white;
  margin: 0;
}

.background {
  background-color: #FFF1D9;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.myModal {
  width: 320px;
  border-radius: 24px;
  display: block;
  margin: 0px auto;
  background-color: white;
  border: solid white 4px;
}

.myModalFull {
  width: 320px;
  border-radius: 24px;
  display: block;
  margin: 0px auto;
  background-color: white;
  border: solid white 4px;
  width: 100%;
  height: 100vh;
}

.over {
  z-index: 3;
  position: absolute;
  top: 0px;
  font-size: 18px;
  left: 0px;
  width: 100%;
  /* min-height: 100vh; */
  height: 100%;

  display: block;
  margin: 0px auto;
  background: rgba(0, 0, 0, 0.7);
}

.center {
  display: block;
  margin: 0px auto;
}

.colorBtn {
  border-radius: 36px;
  min-height: 56px;
  color: white;
}

.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
}

.container {
  margin-top: 16px;
  font-size: 20px;
  /* min-height: 100vh; */
}
</style>
